var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('city-list',{on:{"selectedCity":_vm.selectedCid}}),_c('div',{staticClass:"text"},[_c('div',{staticClass:"textcontent",domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }